import React from "react";

export const DocumentationIcon = (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4649 3.41675H9.13159V14.0834H14.4649C15.2003 14.0834 15.7983 13.4854 15.7983 12.7501V4.75008C15.7983 4.01475 15.2003 3.41675 14.4649 3.41675ZM14.4649 12.0834H10.4649V10.7501H14.4649V12.0834ZM14.4649 9.41675H10.4649V8.08341H14.4649V9.41675ZM14.4649 6.75008H10.4649V5.41675H14.4649V6.75008Z"
      fill="#ffffff"
    />
    <path
      d="M7.79826 3.41675H2.46493C1.72959 3.41675 1.13159 4.01475 1.13159 4.75008V12.7501C1.13159 13.4854 1.72959 14.0834 2.46493 14.0834H7.79826V3.41675Z"
      fill="#ffffff"
    />
  </svg>
);
